/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Spaces_Delete_Space_AriaInputs */



/**
* | output |
* | --- |
* | "Delete space {name}" |
*
* @param {Spaces_Delete_Space_AriaInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const spaces_delete_space_aria = /** @type {((inputs: Spaces_Delete_Space_AriaInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spaces_Delete_Space_AriaInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Space ${i?.name} löschen`)
	return /** @type {LocalizedString} */ (`Delete space ${i?.name}`)
});